<template>
  <v-app>
    <Header></Header>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Header from "./components/top-bar.vue";

export default {
  // props: ['aquarium'],
  name: "App",

  data: () => ({
    //
  }),
  components: {
    Header,
  },
};
</script>

<style scoped>
/* ツールバーの高さと同じ値 */
.main-content {
  margin-top: 45px;
}
</style>
